/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2023-11-07 11:27:03
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-02-05 16:14:25
 * @FilePath: \qcloud-web-pc-4.0\src\router\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { RouteObject, useRoutes } from 'react-router'
import {
  MetaTitle,
} from './tools'
import routeConfig from './routeConfig'
// import Home from '@/views/home'
// import { Navigate } from 'react-router-dom';
import Login from '@/views/Login'
import { LanguageRedirect } from './tools'
import type { IRouteObject } from './routeConfig'

const hideFooter:string[] = []
const hideHeader:string[] = []
const handleConfig = (config: IRouteObject[], parentPath?:string):RouteObject[] => {
  const res = config.map(item => {
    // item.title = item.title ?? 'home';
    if (item.title && item.element) {
      item.element = <MetaTitle title={ item.title }>{ item.element }</MetaTitle>
      // delete item.title
    }
    let { path } = item
    // 合成完整路径
    if (item.index) {
      path = parentPath
    } else if (parentPath && path) {
      if (parentPath.endsWith('/')) {
        path = parentPath + path
      } else {
        path = parentPath + '/' + path
      }
    }
    // 判断路径是不是带参数，把路径转化成正则
    if (path?.includes('/:')) {
      const reg = /\/:[\w\d]{1,}/g
      path = path.replace(reg, '/.{1,}')
    }
    if (item.hideFooter && path) {
      hideFooter.push('/zh/' + path)
      hideFooter.push('/en/' + path)
      delete item.hideFooter
    }
    if (item.hideHeader && path) {
      hideHeader.push('/zh/' + path)
      hideHeader.push('/en/' + path)
      delete item.hideHeader
    }
    if (item.children) {
      item.children = handleConfig(item.children, path)
    }
    return item
  })
  return res
}

const rootes = handleConfig(routeConfig)

const langRoute = [
  {
    path: '',
    element: <Login />,
  },
  {
    path: 'zh',
    children: rootes
  },
  {
    path: 'en',
    children: rootes
  },
  {
    path: '*',
    element: <LanguageRedirect />
  }
]

const RouterView = () => {
  return useRoutes(langRoute)
}
export const hideFooterPathList:string[] = hideFooter
export const hideHeaderPathList:string[] = hideHeader
export default RouterView
